import { render, staticRenderFns } from "./proLisy.vue?vue&type=template&id=427c180c&scoped=true&"
import script from "./proLisy.vue?vue&type=script&lang=js&"
export * from "./proLisy.vue?vue&type=script&lang=js&"
import style0 from "./proLisy.vue?vue&type=style&index=0&id=427c180c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427c180c",
  null
  
)

export default component.exports